import React, { PureComponent } from 'react';
import styled from 'styled-components';
import anime from 'animejs';

const Root = styled.div`
  position: relative;
  width: 80%;
  height: 50%;

  svg {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80%;
    width: 100%;
    max-width: 210px;
    margin: 0 auto;
  }
`;

const Man = styled.img`
  position: absolute;
  height: 65%;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
`;

const Cloud = styled.img`
  position: absolute;
  width: 100%;
  max-width: 230px;
  right: 0;
  left: 0;
  top: 0;
  margin: 0 auto;
`;

type Props = {
  className?: string;
};

export default class RainMan extends PureComponent<Props> {
  componentDidMount() {
    this.animateRain();
  }

  animateRain() {
    const animate = (el: any) =>
      anime({
        targets: el,
        duration: anime.random(1200, 1800),
        easing: 'linear',
        strokeDashoffset: [240, 0],
        loop: true,
      });
    const toAnimate = document.querySelectorAll('#rain');
    for (let i = 0; i < toAnimate.length; ++i) {
      animate(toAnimate[i]);
    }
  }

  drawRain = (_: any, i: any) =>
    i === 0 || i === 9 ? null : (
      <line
        key={i}
        id="rain"
        x1={i * 20 + 20}
        y1="10"
        x2={i * 20}
        y2="240"
        strokeDasharray="20"
        strokeDashoffset="0"
        stroke="#ececec"
        strokeWidth="2"
      />
    );

  render() {
    const { className } = this.props;
    return (
      <Root className={className}>
        {/* @ts-expect-error ts-migrate(2345) FIXME: Type '{ length: number; }' is missing the followin... Remove this comment to see the full error message */}
        <svg>{Array.apply(null, { length: 10 }).map(this.drawRain)}</svg>

        <Man src="/images/homepage/man_sick.png" alt="sad man" />

        <Cloud src="/images/homepage/cloud.svg" alt="rain cloud" />
      </Root>
    );
  }
}
